function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { ScrollableList, CustomModal, Typography } from 'seagull';
import { useResponsive } from "../../../../client-flow/contexts";
import { useStoreActions } from "../../../../contexts";
import { useTutorialVideos } from "../../../../hooks/useTutorialVideos/useTutorialVideos";
import styles from "./TutorialVideosModal.module.scss";
import { TutorialVideosPlayedVideo } from "./TutorialVideosPlayedVideo";
import { VideoCardItem } from "./VideoCardItem/VideoCardItem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TutorialVideosModal(_ref) {
  let {
    dismissModal
  } = _ref;
  const {
    videos,
    handleWatch
  } = useTutorialVideos();
  const {
    logBI
  } = useStoreActions();
  const [currentVideo, setCurrentVideo] = useState(null);
  const {
    isPortrait
  } = useResponsive();
  const playerContainerRef = useRef(null);
  const [playerHeight, setPlayerHeight] = useState(undefined);
  useEffect(() => {
    if (videos.length > 0 && !currentVideo) {
      setCurrentVideo(videos[0]);
    }
  }, [currentVideo, videos]);
  useEffect(() => {
    if (!playerContainerRef.current || isPortrait) {
      setPlayerHeight(undefined);
      return;
    }
    const updateHeight = () => {
      if (playerContainerRef.current) {
        setPlayerHeight(playerContainerRef.current.offsetHeight);
      }
    };
    updateHeight();
    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });
    resizeObserver.observe(playerContainerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [currentVideo, isPortrait]);
  const allVideos = videos.slice(0, -1);
  const lastVideo = videos[videos.length - 1];
  const videoSlider = /*#__PURE__*/_jsxs(ScrollableList, _objectSpread(_objectSpread({
    direction: "vertical",
    maxSize: isPortrait ? '100%' : playerHeight ? "".concat(playerHeight + 24, "px") : '100%',
    gap: 8
  }, isPortrait && {
    itemsInView: 3.5,
    itemMaxSize: 224
  }), {}, {
    children: [allVideos.map(video => /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(VideoCardItem, {
        video: video,
        onSelect: setCurrentVideo,
        isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === video.id,
        variant: isPortrait ? 'portrait' : 'desktop'
      })
    }, video.id)), /*#__PURE__*/_jsx("div", {
      className: styles.lastVideoContainer,
      children: /*#__PURE__*/_jsx(VideoCardItem, {
        video: lastVideo,
        onSelect: setCurrentVideo,
        isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === lastVideo.id,
        variant: isPortrait ? 'portrait' : 'desktop'
      })
    }, lastVideo.id)]
  }));
  const mobileProps = {
    width: '100%',
    contentUseFullWidth: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    maxHeight: 'calc(100% - 32px)'
  };
  return /*#__PURE__*/_jsx(CustomModal, _objectSpread(_objectSpread({
    contentUseFullWidth: true,
    className: cn(styles.TutorialVideosModal, {
      [styles.isPortrait]: isPortrait
    }),
    maxWidth: "calc(100% - 128px)",
    onClose: () => {
      if (currentVideo) {
        logBI(11216, {
          videoId: currentVideo.id,
          title: currentVideo.title
        });
      }
      dismissModal();
    },
    headerClassName: styles.modalTitle,
    header: /*#__PURE__*/_jsx(Typography, {
      weight: "bold",
      "data-testid": "tutorial-videos-modal-title",
      children: "Explore tutorials"
    })
  }, isPortrait && mobileProps), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: cn(styles.modalContent, {
        [styles.isPortrait]: isPortrait
      }),
      children: [currentVideo && /*#__PURE__*/_jsx("div", {
        className: cn(styles.responsivePlayerContainer, {
          [styles.isPortrait]: isPortrait
        }),
        ref: playerContainerRef,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.responsivePlayer,
          children: /*#__PURE__*/_jsx(TutorialVideosPlayedVideo, {
            video: currentVideo,
            onWatch: handleWatch
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cn(styles.modalVideosSliderContainer, {
          [styles.isPortrait]: isPortrait
        }),
        children: videoSlider
      })]
    })
  }));
}